import { v4 as uuid } from 'uuid';
import Core from '../Core/Core';
import { IGameState, IStateSubcriber, IWatcher } from '../State/Store/store';

export class Manager {
    protected readonly listeners: Array<IStateSubcriber<any>> = [];
    protected readonly watchers: Array<IWatcher<any>> = [];

    public cleanUp() {
        Core.store.removeListener(this.listeners);
        Core.store.removeWatcher(...this.watchers);
    }

    protected addSelector(
        callback: (state: any, previousState: any) => void,
        selector: (state: IGameState) => any = (state: IGameState) => state
    ) {
        const createdListener = {
            callback: callback.bind(this),
            selector,
            id: callback.constructor.name + '-' + uuid(),
        };

        Core.store.addListener([createdListener]);
        this.listeners.push(createdListener);
    }

    protected addWatcher(
        callback: (state: any, previousState: any) => void,
        selector: (state: IGameState) => any = (state: IGameState) => state
    ) {
        const createdWatcher = {
            callback: callback.bind(this),
            selector,
        };

        Core.store.addWatcher(createdWatcher);
        this.watchers.push(createdWatcher);
    }

    protected update() {}
}
